<div class="side-bar__content">
  <ng-content></ng-content>
</div>
